import React from "react";
import { Header as HeaderWithLogo, Logo } from "mf-ui-components";

export const Header = () => (
  <HeaderWithLogo logoContent={<Logo href="https://www.moneyfarm.com" />} />
);
